import React, {useContext} from "react";
import {useQueryUniqueUsers} from "../../queries/pharmacy/hooks/useQueryUniqueUsers";
import {UserContext} from "../../hooks/userContext";
import {CircularProgress} from "@mui/material";
import {useQueryUniquePharmacy} from "../../queries/pharmacy/hooks/useQueryUniquePharmacy";
import Paper from "@mui/material/Paper";
import {useQueryPharmacyOptions} from "../../queries/pharmacy/hooks/useQueryPharmacyOptions";
import PharmacyDetails from "./PharmacyDetails";
import PhysicalAddress from "./PhysicalAddress";
import OtherDetails from "./OtherDetails";
import ReviewFollowingStatements from "./ReviewFollowingStatements";
import PharmacyFiles from "./PharmacyFiles";
import PharmacyBusinessInformation from "./PharmacyBusinessInformation";

const PharmacyProfile:React.FunctionComponent = () => {
  const { id }: any = useContext(UserContext);

  const {data: pharmacyUsersData, loading: pharmacyUsersLoading } = useQueryUniqueUsers({
    variables: { where: { id:  +id } },
  });

  const {data: pharmacyOptionData, loading: pharmacyOptionsLoading} = useQueryPharmacyOptions({});
  const {data: pharmacyData, loading: pharmacyLoading } = useQueryUniquePharmacy({
    variables: { where: { id: pharmacyUsersData.findUniqueUser.PharmacyUsers[0].pharmacyId } },
    skip: !pharmacyUsersData
  });

  if (pharmacyUsersLoading || pharmacyLoading || pharmacyOptionsLoading) {
    return <CircularProgress sx={{position: 'absolute', left: 'calc(150px + 50%)', top: '50%'}} color="inherit" />
  }

  return (
    <>
      <Paper sx={{ p: 2, mb: 2, display: 'flex', flexDirection: 'column' }}>
        <PharmacyFiles
          pharmacy={pharmacyData.findUniquePharmacy}
          statuses={pharmacyOptionData.findManyStatus}
        />
      </Paper>
      <Paper sx={{ p: 2, mb: 2, display: 'flex', flexDirection: 'column' }}>
        <PharmacyDetails
          data={pharmacyData.findUniquePharmacy}
          states={pharmacyOptionData.findManyState}
          pharmacyId={pharmacyUsersData.findUniqueUser.PharmacyUsers[0].pharmacyId}
        />
      </Paper>
      <Paper sx={{ p: 2, mb: 2, display: 'flex', flexDirection: 'column' }}>
        <PhysicalAddress
          data={pharmacyData.findUniquePharmacy.PharmacyAddress}
          states={pharmacyOptionData.findManyState}
          pharmacyId={pharmacyUsersData.findUniqueUser.PharmacyUsers[0].pharmacyId}
        />
      </Paper>
      <Paper sx={{ p: 2, mb: 2, display: 'flex', flexDirection: 'column' }}>
        <PharmacyBusinessInformation
          data={pharmacyData.findUniquePharmacy}
        />
      </Paper>
      <Paper sx={{ p: 2, mb: 2, display: 'flex', flexDirection: 'column' }}>
        <OtherDetails
          data={pharmacyData.findUniquePharmacy.PharmacyDetail}
          pharmacyId={pharmacyUsersData.findUniqueUser.PharmacyUsers[0].pharmacyId}
          pharmacyTypes={pharmacyOptionData.findManyPharmacyType}
        />
      </Paper>
      <Paper sx={{ p: 2, mb: 2, display: 'flex', flexDirection: 'column' }}>
        <ReviewFollowingStatements data={pharmacyData.findUniquePharmacy.PharmacyStatement} />
      </Paper>
    </>
  );
}

export default PharmacyProfile;